import { isGuidancePage } from "./installPrompt";

/**
 * Staff pages install "ANNA Guidance" (admin-manifest.json, navy icon), student pages "ANNA".
 * A script in index.html sets the right tags when a page first loads; this keeps them right
 * when someone moves between the two sides without a reload (say, the landing page's
 * staff sign-in link), because the phone reads them when Add to Home Screen is tapped.
 */
const BASE = process.env.PUBLIC_URL || "";

const setAttr = (selector, name, value) => {
  const element = document.querySelector(selector);
  if (element && element.getAttribute(name) !== value) element.setAttribute(name, value);
};

export function syncAppManifest(pathname) {
  try {
    const staff = isGuidancePage(pathname);
    setAttr('link[rel="manifest"]', "href", `${BASE}/${staff ? "admin-manifest.json" : "manifest.json"}`);
    setAttr('link[rel="apple-touch-icon"]', "href", `${BASE}/${staff ? "guidance/apple-touch-icon.png" : "apple-touch-icon.png"}`);
    setAttr('meta[name="apple-mobile-web-app-title"]', "content", staff ? "Guidance" : "ANNA");
    document.querySelectorAll('link[rel="apple-touch-startup-image"]').forEach((link) => {
      const href = link.getAttribute("href") || "";
      const next = staff ? href.replace(/\/(?:guidance\/)?splash\//, "/guidance/splash/") : href.replace("/guidance/splash/", "/splash/");
      if (next !== href) link.setAttribute("href", next);
    });
  } catch (error) {
    // Only the home screen icon is at stake; never break the page over it.
  }
}
